import createHttp from '@/config/http';
import type {
	Tutorial,
	TutorialsRemainingResponse,
	TutorialsResponse,
	UpdateTutorialsRemainingPayload,
	UpdateTutorialsRemainingResponse,
} from '@/types/tutorials';

const http = createHttp(import.meta.env.VITE_COMMON_URL);

export const getTutorialsRemaining = async (
	userId: string,
): Promise<TutorialsRemainingResponse['data']> => {
	const response = await http.get<TutorialsRemainingResponse>(
		'/common/tutorialsRemaining',
		{
			params: {
				userId,
			},
		},
	);
	return response.data.data;
};

export const updateTutorialsRemaining = async (
	payload: UpdateTutorialsRemainingPayload,
): Promise<UpdateTutorialsRemainingResponse['data']> => {
	const response = await http.post<UpdateTutorialsRemainingResponse>(
		'/common/tutorialsRemaining',
		payload,
	);
	return response.data.data;
};

export const getTutorials = async (): Promise<Tutorial[]> => {
	const response = await http.get<TutorialsResponse>('/common/tutorials');
	return response.data.data;
};
